import styled, { keyframes, css } from 'styled-components';
const pulseShadow = /*#__PURE__*/keyframes(["0%{box-shadow:0px 0px 30px 15px rgba(193,192,192,0.4);}50%{box-shadow:0px 0px 10px 5px rgba(64,64,64,0.6);}100%{box-shadow:0px 0px 30px 15px rgba(193,192,192,0.4);}"]);
export const Container = /*#__PURE__*/styled.div.withConfig({
  displayName: "BotWithAnumatedBorderstyles__Container",
  componentId: "sc-10iqj6d-0"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;"]);
export const LogoWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "BotWithAnumatedBorderstyles__LogoWrapper",
  componentId: "sc-10iqj6d-1"
})(["width:88px;height:88px;position:relative;top:50px;display:flex;border-radius:50%;align-items:center;justify-content:center;", ""], ({
  isSpeaking
}) => isSpeaking && css(["animation:", " 2.5s cubic-bezier(0.42,0,0.58,1) infinite;"], pulseShadow));
export const Logo = /*#__PURE__*/styled.img.withConfig({
  displayName: "BotWithAnumatedBorderstyles__Logo",
  componentId: "sc-10iqj6d-2"
})(["width:100%;height:100%;border-radius:50%;"]);
export const ToggleButton = /*#__PURE__*/styled.button.withConfig({
  displayName: "BotWithAnumatedBorderstyles__ToggleButton",
  componentId: "sc-10iqj6d-3"
})(["margin-top:20px;padding:10px 20px;font-size:16px;cursor:pointer;"]);